function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6773 8.1313L11.0009 0.657872C10.2536 0.124056 9.18596 0.657872 9.18596 1.61874V3.86077C9.18596 4.50135 8.65215 5.03517 8.01157 5.03517H1.28548C0.6449 5.03517 0.111084 5.56898 0.111084 6.20956V11.868C0.111084 12.5086 0.6449 13.0424 1.28548 13.0424H7.9048C8.54538 13.0424 9.0792 13.5762 9.0792 14.2168V16.4588C9.0792 17.4197 10.1468 17.9535 10.8942 17.4197L21.5705 9.94628C22.3178 9.51922 22.3178 8.55835 21.6773 8.1313Z",
  className: "color-fill",
  fill: "white"
});
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.8223a760afaed558ae93bb8e99b9cde1.svg";
export { ForwardRef as ReactComponent };